import { Tag, Divider,Button, Card, Checkbox, Classes, Dialog, FileInput, H4, H5, Icon, Intent, MenuItem, Radio, RadioGroup, Spinner, ProgressBar, Collapse, EditableText, H3, Tooltip, Position } from '@blueprintjs/core';
import React from 'react';
import { StepCard, uploadIcon, DownArrow, TitleMenu } from '../_components';
import './UploadPage.css';
import i18n from 'i18next';
import {NetworkToaster, defaultSelectFieldPredicate, defaultSelectFieldRenderer, defaultSelectItemPredicate, defaultSelectItemRenderer, history, postWithToken, streamWithToken } from '../_helpers';
import '../../node_modules/@blueprintjs/table/lib/css/table.css';
import '../../node_modules/@blueprintjs/select/lib/css/blueprint-select.css';

// import '../../node_modules/@blueprintjs/core/lib/css/blueprint.css';
import {Cell, Column, Table} from '@blueprintjs/table';
import { Select } from '@blueprintjs/select';
import { MatchItem } from '../_components/MatchItem';

import {FileDrop} from 'react-file-drop';

const upload_initialState = {
    loading:false,
    spreadsheetColumns:[],
    databaseColumns:{},
    permanentlyDisabledSpreadsheetColumns:[],

    /* card1 - upload related */
    file:null, //string of filename
    fileUploading:false,
    fileExtension:null,
    sampleTable:null,

    /* card2 - select patient no */
    selectedPatientNumberColumn:null,
    selectedPatientNameColumn:null,
    useHospitalNumber:false,

    /* card3 - match */
    matchSpreadsheetColumn:null,
    matchDatabaseColumn:null, 
    matches:{}, // {spreadsheet : '', database:{field}}

    /* card 4 - config */
    conflict:0,
    create:0,
    
    /* sample dialog */
    sampleDialogIsOpen:false,

    /* uploading */
    uploading:false,
    showUploadCard:false,
    progress:0,
    affected:0,
    total:0,
    paused:false,
    errors:[],
    showErrors:false,


    /* menu - templates */
    title:"",
    templateIdx:0,
    changed:false,
    templateListOpen:false,
    templateLoading:false,
    templateList:[],
    owner:false,
    ownerName:null,
    shared:false,
    shareAlertOpen:false,

    



}


class UploadPage extends React.Component { 


    constructor(props) {
        super(props);
        this.state = upload_initialState;
        this.uploadSource = null;
        this.history = 0;
        this.duplicate = false; //used to decide if saving model is currently duplicate -> set before setting share alert open to true
    }

    componentDidMount() {
        this.populate();
    }

    initializeState = () => {
        this.setState(upload_initialState);
    }

    populate = () => {
        /** populate from DB */
        this.initializeState();
        this.setState({loading:true});

        postWithToken('upload/currentTemplate.php',{tableIdx:this.props.currentTable},data => {
            //populate with data
            
            if(data.hasData) {
                // console.log(data.state);
                //permanently disable
                let newState = data.state;

                //pre-process state
                if(!newState.matches) newState.matches = "{}";
                newState.matches = JSON.parse(newState.matches);
                newState.conflict = parseInt(newState.conflict);
                newState.create = parseInt(newState.create);

                //check for false matches
                let newMatches = {};

                Object.entries(newState.matches).map((match, index) => {
                    if(match[1] in newState.databaseColumns) {
                        //not in database, so remove this
                        newMatches[match[0]] = match[1];
                    }

                });
                if(Object.keys(newMatches).length !== Object.keys(data.state.matches).length) {
                    postWithToken('upload/saveMatch.php', {
                        tableIdx:this.props.currentTable, matches:JSON.stringify(newMatches), changed:true
                    });
                }
                newState.matches = newMatches;


                
                this.setState(newState, () => {
                    this.extractColumns();
                    //if there was changes in matches, then save
                    // if(newMatches.length !== data.state.matches.length) {
                        // this.saveMatch();
                    // }
                });
            }
        },(errorMessage,data) => {
            if(data !== null) {
                if(data.message === 'no_permission') {
                    //then return to tables
                    history.push('/');
                } else {
                    NetworkToaster.show({message:errorMessage, intent:Intent.DANGER, icon:"warning-sign"});
                }

            }
        }, data => this.setState({loading:false}));
    }

    /****
     * CARD 1
     */
    onFileChange = (file) => {
        /**
         * uploads the file and displays preview of the file
         */
        /**
         * e.target.files : list of {name:''}
         */

        // this.initializeState();

        this.setState({fileUploading:true});

        var data = new FormData();
        data.append('file',file);
        data.append('tableIdx', this.props.currentTable);

        if (typeof FileReader !== "undefined") {
            var size = file.size;
            var sizeInMb = size/1000000;
            if(sizeInMb > 199) {
                //too large
                alert(i18n.t("upload.file-size-too-large"));
                return;
            }
        }


        postWithToken('upload/uploadFile.php',data,(data) => {
            // console.log(data.fileName);
            //success
            this.setState({file:data.fileName, fileExtension:data.extension, sampleTable:data.table}, () => {
                this.extractColumns();
            });
            
        },null,(data) => {
            this.setState({fileUploading:false, changed:true});
        }, true);

    }

    sampleTableCellRenderer = (rowIndex, columnIndex) => {
        const {sampleTable} = this.state;
        return <Cell>
            {typeof sampleTable[rowIndex+1][columnIndex] === 'object' ?  sampleTable[rowIndex+1][columnIndex].date : sampleTable[rowIndex+1][columnIndex]}
        </Cell>
    }
    getSampleTable = () => {
        const {sampleTable} = this.state;
        return <Table numRows={sampleTable.length-1} className="upload-sample-table">
            {sampleTable[0].map((column) => <Column name={column} cellRenderer={this.sampleTableCellRenderer} />)}
        </Table>;

    }
    /*** 
     * Card 2
     */
    extractColumns = () => {
        
        const {sampleTable} = this.state;

        

        if(sampleTable && sampleTable.length > 0) {
            let newState = {};
            //make spreadsheetcolumns
            newState.spreadsheetColumns = Array.from(sampleTable[0]);
            //make permanently disabled (duplicate or empty columns)
            newState.permanentlyDisabledSpreadsheetColumns = newState.spreadsheetColumns.filter(column => this.isNotQualified(column,newState.spreadsheetColumns));

            if(!this.state.selectedPatientNumberColumn) {
                newState.selectedPatientNumberColumn = null;
            }

            if(!this.state.selectedPatientNameColumn) {
                newState.selectedPatientNameColumn = null;
            }

            //check if newly set columns includes previously set patient number column
            if(newState.spreadsheetColumns.indexOf(this.state.selectedPatientNumberColumn) === -1) {
                //this column is not present so initialize;
                newState.selectedPatientNumberColumn = null;
            }

            

            //else, just include the previously saved patient number column

            this.setState(newState);
        } else {
            let newState = {spreadsheetColumns:[],
                permanentlyDisabledSpreadsheetColumns:[],};
            if(!this.state.selectedPatientNumberColumn) {
                newState.selectedPatientNumberColumn = null;
            }

            if(!this.state.selectedPatientNameColumn) {
                newState.selectedPatientNameColumn = null;
            }

            this.setState(newState);
        }

    }
    
    selectedPatientNumberColumn = (column, event) => {
        this.setState({selectedPatientNumberColumn:column, changed:true});
        //send to server
        postWithToken('upload/setPatientColumn.php',{
            tableIdx:this.props.currentTable,
            patientColumn:column
        })

    }

    selectedPatientNameColumn = (column) => {
        this.setState({selectedPatientNameColumn:column, changed:true});
        //send to server
        postWithToken('upload/setPatientColumn.php',{
            tableIdx:this.props.currentTable,
            patientName:column,
            eraseName:column ? 0:1,
        })

    }

    changedUseHospitalNumber = (use)=> {
        this.setState({useHospitalNumber:use, changed:true});
        postWithToken('upload/setPatientColumn.php',{
            tableIdx:this.props.currentTable,
            preanonymized: use ? 1:0,
        });
        //send to server
    }

    /**
     * Card 3
     */
    isNotQualified = (column, array) => {
        //duplicate column
        //empty column
        if(String(column).trim() === "") return true;

        var idx = array.indexOf(String(column));
        var found = false;
        var duplicate =false;
        while(idx !== -1) {
            if(found) {
                duplicate=true;
                break;
            } else {
                found = true;
                idx = array.indexOf(String(column), idx+1);
            }
        }
        if(duplicate) return true;

        return false;

    }
    selectedMatchSpreadsheetColumn = (column, event) => {
        this.setState({matchSpreadsheetColumn:column});

    }
    isSpreadsheetColumnDisabled = (column,index, exception = null) => {
        if(this.state.permanentlyDisabledSpreadsheetColumns.indexOf(column) > -1) return true;

        if(column === exception) return false;
        if(this.state.selectedPatientNumberColumn === column) return true;
        if(this.state.selectedPatientNameColumn === column) return true;

        if(Object.keys(this.state.matches).indexOf(column) > -1) return true;

        else return false;

    }
    selectedMatchDatabaseColumn = (field, event) => {
        this.setState({matchDatabaseColumn:field});
    }
    isDatabaseColumnDisabled = (field, index) => {
        if(Object.values(this.state.matches).indexOf(field.fieldIdx) > -1) return true;
        return false;

    }

    addMatch = () => {

        const {matchSpreadsheetColumn, matchDatabaseColumn} = this.state;
        //check all is filled
        if(matchSpreadsheetColumn !== null && matchDatabaseColumn !== null) {

            let newState = this.state.matches;
            newState[matchSpreadsheetColumn] = matchDatabaseColumn.fieldIdx;

            this.setState({
                matches:newState,
                matchSpreadsheetColumn:null,
                matchDatabaseColumn:null,
            }, () => {

                this.saveMatch();
            });


        } //check filled

    }
    removeMatch = (key) => {
        let newState =this.state.matches;
        delete newState[key];
        this.setState({
            matches:newState,
        }, () => {
            this.saveMatch();
        });

    }
    saveMatch = () => {
        postWithToken('upload/saveMatch.php', {
            tableIdx:this.props.currentTable, matches:JSON.stringify(this.state.matches), changed:true
        });
    }
    isMatchDisabled = (spreadsheet) => {
        const {spreadsheetColumns, permanentlyDisabledSpreadsheetColumns} = this.state;
        if(spreadsheet.trim()==="") return true;
        if(spreadsheetColumns.indexOf(spreadsheet) === -1) return true;
        if(permanentlyDisabledSpreadsheetColumns.indexOf(spreadsheet) > -1) return true;
        return false;
    }

    /**
     * CARD 4
     */
    onConfigChange = (type, value) => {
        this.setState({
            [type] : parseInt(value), changed:true,
        });

        postWithToken('upload/saveConfig.php', {tableIdx:this.props.currentTable,[type] : value});

    }


    /**
     * SAMPLE DIALOG
     */
    showSampleDialog = () => {
        this.setState({sampleDialogIsOpen:true});
    }
    getSpreadsheetIndex = (column) => {
        return this.state.spreadsheetColumns.indexOf(column);
    }

    /**
     * CONFIRM UPLOAD
     */
    startStream = (initialize = false) => {
        if(initialize) {
            //remove previously set variables
            if(this.uploadSource) this.uploadSource.close();
            this.history =0 ;
            this.setState({paused:false, errors:[], showErrors:false, progress:0, affected:0, total:0,});
        }
        postWithToken('upload/prepare.php', {tableIdx:this.props.currentTable, history:this.history}, (data) => {
            
            this.history = data.history;

            //start upload
            this.uploadSource = streamWithToken('upload/start.php',data.auth,{tableIdx:this.props.currentTable, progress:this.state.progress, affected:this.state.affected, history:this.history, multi:(this.props.currentTableIsMulti==="multi" ? 1 :0)}, {
                message : (e) => {
                    //e.data
                    const data = JSON.parse(e.data);
                    // console.log(data);
                    if(data.progress !== undefined) {
                        this.setState({
                            progress:parseInt(data.progress),
                            affected:parseInt(data.affected),
                            total:parseInt(data.total),
                            
                        })
                    }
            
                    if(data.status ==='completed') {
                        
                        alert(i18n.t('upload.completed'));
                        this.uploadSource.close();
                        this.setState({uploading:false});
                        this.history = 0;
                    }
                    
                },
                error:(e) => {
                    // data.type = ignore | fail | error

                    if(e.data !== undefined) {
                        const data = JSON.parse(e.data);
                        // console.log(data);

                        if(data.progress !== undefined) {
                            this.setState({
                                progress:parseInt(data.progress),
                                affected:parseInt(data.affected),
                                total:parseInt(data.total),
                            })
                        }


                        if(data.type === 'error') {
                            alert(i18n.t(`error.${data.message}`));
                            this.uploadSource.close();
                            this.history = 0;

                        } else if (data.type==='ignore') {
                            //save to this.state.errors
                            let newState = this.state.errors;
                            if(data.message !== undefined) {
                                newState.push(i18n.t(`upload.error-${data.message}`, data));
                            } else {
                                newState.push(i18n.t(`upload.error-general`, {row:data.progress+1}));

                            }
                            this.setState({errors:newState});
                        } else if(data.type==='fail') {
                            //failed
                            //save to this.state.errors
                            let newState = this.state.errors;
                            newState.push(i18n.t(`upload.error-failed`, data));
                            this.setState({errors:newState});

                        }
                    }
                }
            });


        },(error) => { //post error
            alert(error);
            this.setState({uploading:false});
        });
        

    }
    
    confirmUpload = () => {
        this.setState({sampleDialogIsOpen:false, uploading:true, showUploadCard:true});
        //now really upload
        window.scrollTo(0,document.body.scrollHeight);
        this.startStream(true);

    }
    pauseUpload = () => {
        this.uploadSource.close();
        this.setState({uploading:false, paused:(this.state.progress < this.state.total) ? true : false});

    }
    resumeUpload = () => {
        this.setState({sampleDialogIsOpen:false, uploading:true, showUploadCard:true, paused:false});
        this.startStream();
    }


    /** MENU related */
    changedTitle = (value) => {
        this.setState({title:value, changed:true});
    }
    confirmTitleChange = (value) => {
        this.setState({title:value});
        postWithToken("upload/setTemplateName.php", {tableIdx:this.props.currentTable, name:value});
    }

    resetAll = () => {
        //confirm,
        //reset all state
        //erase desktop template on the server
        if(this.state.changed) {
            //confirm
            let confirm = window.confirm(i18n.t("template.confirm-reset"));
            if(!confirm) return;
        } 

        postWithToken('upload/reset.php',{tableIdx:this.props.currentTable});
        this.setState(upload_initialState);

    }
    showOpenTemplate = () => {
        this.setState({templateListOpen:true, templateLoading:true, templateList:[
            // fake data
            {name:"aaaaaaaaaaaaaaaaaa", matches:"{}", share:0},
            {name:"aaaaaaaaaaa", matches:"{}", share:1},
            {name:"aaaaaaa", matches:"{}", share:0},
            {name:"aaaaaaaaaaaaa", matches:"{}", share:0},
            {name:"aaaaaaaaaaaaaaa", matches:"{}", share:1},
        ]});
        postWithToken('upload/templateList.php', {tableIdx:this.props.currentTable},(data) => {
            // console.log(data.list);
            this.setState({
                templateList:data.list,
            });
        }, null, data => {
            this.setState({templateLoading:false});
        });
    }
    closeOpenTemplate = () => {
        this.setState({templateListOpen:false});

    }

    showSaveTemplate = () => {
        this.duplicate = false;
        if(this.state.templateIdx > 0) {
            //if previous template_idx then just save
            this.saveTemplate();
            

        } else {
            //if not, set if this should be shared
            this.setState({shareAlertOpen:true});
            
        }
    }
    saveTemplate = (sharing = false) => {
        this.setState({loading:true});
        postWithToken('upload/saveTemplate.php',{tableIdx:this.props.currentTable, sharing:sharing ? 1 : 0, duplicate : this.duplicate ? 1: 0},data => {
            this.setState({changed:false, templateIdx:parseInt(data.templateIdx)});
        },null,data => this.setState({loading:false, shareAlertOpen:false,}));
    }
    showSaveAsTemplate = () => {
        this.duplicate = true;
        this.setState({shareAlertOpen:true});
    }
    openTemplate = (templateIdx) => {
        let confirmOpen = false;
        if(this.state.changed === true && !this.checkIsEmpty()) {
            confirmOpen = window.confirm(i18n.t("template.confirm-open"));
        }
        if(this.state.changed === false || confirmOpen || this.checkIsEmpty()) {
            this.setState({loading:true});
            this.initializeState();
            postWithToken('upload/open.php',{tableIdx:this.props.currentTable, templateIdx:templateIdx},(data)=> {
                let newState = data.state;

                //pre-process state
                if(!newState.matches) newState.matches = "{}";
                newState.matches = JSON.parse(newState.matches);
                newState.conflict = parseInt(newState.conflict);
                newState.create = parseInt(newState.create);
                
                this.setState(newState, () => {
                    this.extractColumns();
                });

            },null,data => {this.setState({loading:false})});

        }

    }
    deleteTemplate = () => {
        if(window.confirm(i18n.t("template.confirm-delete"))) {
            this.setState({loading:true});
            postWithToken('upload/deleteTemplate.php', {tableIdx:this.props.currentTable}, data => {
                //done remove, so reset everything
                this.setState(upload_initialState);
            }, null, data => this.setState({loading:false}) );

        }

    }
    checkIsEmpty = () => {
        if(this.state.templateIdx > 0 || 
            !!this.state.selectedPatientNumberColumn ||
            !!this.state.selectedPatientNameColumn  ||
            !!this.state.useHospitalNumber ||
            Object.values(this.state.matches).length > 0 ||
            this.state.conflict > 0 || this.state.create > 0 ||
            !!this.state.title ||
            !!this.state.file
        ) return false;
        else return true;

    }


    render () {


        const Card1 = [
            <div style={{display:"flex",flexDirection:"row"}}>
                <FileInput hasSelection={this.state.file !== null} 
                    disabled={this.state.fileUploading || this.state.uploading} 
                    text={this.state.file ?? i18n.t("upload.upload-spreadsheet")} 
                    buttonText={i18n.t("upload.select-file")} 
                    onInputChange={(e)=>{this.onFileChange(e.target.files[0]);}}
                    inputProps={{
                        accept:".xlsx,.csv,.ods"
                    }} />
                {this.state.fileUploading && <Spinner size={20} className="upload-file-spinner" />}
            </div>,
            this.state.fileExtension==="csv" && <div className="bp3-text-small warning-text">{i18n.t("upload.csv-warning")}</div>,
            this.state.file !== null && this.getSampleTable(),
            this.state.permanentlyDisabledSpreadsheetColumns != null &&this.state.permanentlyDisabledSpreadsheetColumns.length > 0 && <div className="bp3-text-small warning-text" style={{marginTop:'10px'}}>{i18n.t("upload.disabled-warning")}</div>
        ];

        const Card2 = [
            <Select 
                disabled={this.state.uploading}
                items={this.state.spreadsheetColumns} 
                itemRenderer={defaultSelectItemRenderer}
                itemPredicate={defaultSelectItemPredicate}
                onItemSelect={this.selectedPatientNumberColumn}
                activeItem={this.state.selectedPatientNumberColumn}
                itemDisabled={(column,index) => this.isSpreadsheetColumnDisabled(column,index,this.state.selectedPatientNumberColumn)}
                >
                <Button outlined={this.state.selectedPatientNumberColumn === null} text={this.state.selectedPatientNumberColumn ?? i18n.t("upload.select-patient-no")}  rightIcon="double-caret-vertical" intent={Intent.SUCCESS} />
            </Select>,
            <Checkbox
                disabled={this.state.uploading}
                className="upload-use-hospital-no"
                checked={this.state.useHospitalNumber}
                onChange={(e) => this.changedUseHospitalNumber(e.target.checked)}
                label={i18n.t("upload.use-hospital-number")}
                    />,
            this.state.useHospitalNumber && <div className="subtitle" style={{marginTop:'15px'}}>{i18n.t("upload.card-subtitle-2-1")}</div>, 
            this.state.useHospitalNumber && <div className="upload-row">
                <Select 
                    disabled={this.state.uploading}
                    items={this.state.spreadsheetColumns} 
                    itemRenderer={defaultSelectItemRenderer}
                    itemPredicate={defaultSelectItemPredicate}
                    onItemSelect={this.selectedPatientNameColumn}
                    activeItem={this.state.selectedPatientNameColumn}
                    itemDisabled={(column,index) => this.isSpreadsheetColumnDisabled(column,index,this.state.selectedPatientNameColumn)}
                    >
                    <Button outlined={this.state.selectedPatientNameColumn === null} text={this.state.selectedPatientNameColumn ?? i18n.t("upload.select-patient-name")}  rightIcon="double-caret-vertical" intent={Intent.SUCCESS} />
                </Select>
                <Button disabled={!this.state.selectedPatientNameColumn} onClick={()=>this.selectedPatientNameColumn(null)} minimal={true} icon="small-cross" />
            </div>,
        ];
        const Card3 = [
            <div className="upload-row">
                <Select 
                    disabled={this.state.uploading}
                    items={this.state.spreadsheetColumns}
                    itemRenderer={defaultSelectItemRenderer}
                    itemPredicate={defaultSelectItemPredicate}
                    onItemSelect={this.selectedMatchSpreadsheetColumn}
                    itemDisabled={this.isSpreadsheetColumnDisabled}
                    activeItem={this.state.matchDatabaseColumn}
                    >
                    <Button  outlined={this.state.matchSpreadsheetColumn === null} text={this.state.matchSpreadsheetColumn ?? i18n.t("upload.select-spreadsheet-match")}  rightIcon="double-caret-vertical" intent={Intent.SUCCESS} />

                </Select>
                <Icon icon="chevron-right" color="#AAA" style={{marginLeft:'10px', marginRight:'10px'}} />
                <Select 
                    disabled={this.state.uploading}
                    items={this.state.databaseColumns ? Object.values(this.state.databaseColumns) : []}
                    itemRenderer={defaultSelectFieldRenderer}
                    itemPredicate={defaultSelectFieldPredicate}
                    onItemSelect={this.selectedMatchDatabaseColumn}
                    itemDisabled={this.isDatabaseColumnDisabled}
                    activeItem={this.state.matchDatabaseColumn}
                    >
                    <Button  outlined={this.state.matchDatabaseColumn === null}  text={this.state.matchDatabaseColumn ? this.state.matchDatabaseColumn.name : i18n.t("upload.select-database-match")}  rightIcon="double-caret-vertical" intent={Intent.PRIMARY} />

                </Select>
                <Button  onClick={()=>this.addMatch()} disabled={this.state.matchDatabaseColumn===null || (this.state.matchSpreadsheetColumn===null || !this.state.matchSpreadsheetColumn || this.state.uploading)} outlined={true} icon="small-plus" text={i18n.t("upload.add-match")} style={{marginLeft:'20px'}} />

            </div>,
            <div className="upload-match-list">
                {(this.state.matches === null || Object.values(this.state.matches).length ===0) && <span className="empty">
                    {i18n.t("upload.empty-matches")}
                </span>}
                {this.state.matches!==null && Object.values(this.state.matches).length >0 && Object.entries(this.state.matches).map((obj, index) => {
                    if(this.state.databaseColumns[obj[1]] !== undefined) {
                        return <MatchItem disabled={this.isMatchDisabled(obj[0])} key={obj[0]} spreadsheet={obj[0]} database={this.state.databaseColumns[obj[1]].name} onRemove={() => this.removeMatch(obj[0])} />;

                    } else {
                        return null;
                    }
                })}

            </div>
        ];

        const Card4 = [
            // <div className="subtitle" style={{marginTop:'20px'}}>{i18n.t("upload.card-subtitle-4")}</div>,
            // <RadioGroup
            //     disabled={this.state.uploading}
            //     onChange={(event) => this.onConfigChange('conflict',event.currentTarget.value)}
            //     selectedValue={this.state.conflict}
            //     inline={true}
            //     >
            //     <Radio label={i18n.t('upload.config-conflict-0')} value={0} />
            //     <Radio label={i18n.t('upload.config-conflict-1')} value={1} />
                
            // </RadioGroup>,


            <div className="subtitle" style={{marginTop:'15px'}}>{i18n.t("upload.card-subtitle-5")}</div>,
            <RadioGroup
                disabled={this.state.uploading || !this.state.useHospitalNumber || this.props.currentTableIsMulti ==="multi"}
                onChange={(event) => this.onConfigChange('create',event.currentTarget.value)}
                selectedValue={this.state.create}
                inline={true}
                >
                <Radio label={i18n.t('upload.config-create-0')} value={0} />
                <Radio label={i18n.t('upload.config-create-1')} value={1} />
                
            </RadioGroup>,
            this.props.currentTableIsMulti === "single" && !this.state.useHospitalNumber && <span className="warning-text bp3-text-small">{i18n.t("upload.create-disabled")}</span>,
            this.props.currentTableIsMulti === "multi" && <span className="blue-text bp3-text-small">{i18n.t("upload.multiple-always-create")}</span> 

        ];

        const SampleDialog = <Dialog title={i18n.t('upload.sample-dialog-title')} isOpen={this.state.sampleDialogIsOpen} onClose={() => this.setState({sampleDialogIsOpen:false})}>
            <div className={Classes.DIALOG_BODY}>
                <H5>{i18n.t("upload.sample-dialog-sample")} <small>({Object.values(this.state.matches).length})</small></H5>
                {this.state.sampleTable && this.state.matches !== null && Object.entries(this.state.matches).map((match, index) => {
                    const spreadsheet =match[0];
                    const fieldIdx = match[1];
                    const field = this.state.databaseColumns[fieldIdx];
                    const fieldName = field.name;

                    //get spreadsheet's index
                    const spreadsheetIndex = this.getSpreadsheetIndex(spreadsheet);
                    const spreadsheetValue = this.state.sampleTable[1][spreadsheetIndex];


                    return <div className="upload-sample-dialog-item" key={index}>
                        <span>{fieldName} <span className="key">({field.key})</span></span><Icon icon="caret-right" /> <span className="value">{spreadsheetValue}</span>
                    </div>;
                })}

                <H5 style={{marginTop:'20px'}}>{i18n.t("upload.sample-dialog-options")}</H5>
                {/* <div className="upload-sample-dialog-config">{i18n.t(this.state.conflict > 0 ? "upload.sample-dialog-config-conflict-no" : "upload.sample-dialog-config-conflict-yes")}</div> */}
                <div className="upload-sample-dialog-config">{i18n.t(this.state.create > 0 ? "upload.sample-dialog-config-create-no" : "upload.sample-dialog-config-create-yes")}</div>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button onClick={() => this.setState({sampleDialogIsOpen:false})} minimal={true} text={i18n.t("general.cancel")} />
                    <Button onClick={()=> this.confirmUpload()} intent={Intent.WARNING} text={i18n.t("upload.start-upload")} />
                </div>
            </div>

        </Dialog>

        const ProgressCard = <Card className="step-card" elevation={0} style={{marginBottom:'100px', opacity:this.state.showUploadCard ? 1 : 0.3}}>
            <div className="title" style={{marginLeft:'0px'}}>{i18n.t("upload.progress-title")}</div>
            
            <div style={{marginTop:'20px'}}>
                <span className="count affected">{this.state.affected}</span> <span className="desc affected">{i18n.t("upload.progress-affected")}</span>
                <span className="count ignored">{this.state.progress - this.state.affected}</span> <span className="desc ignored">{i18n.t("upload.progress-ignored")}</span>
                <span className="count total">{this.state.total}</span> <span className="desc total">{i18n.t("upload.progress-total")}</span>

            </div>
            <ProgressBar value={this.state.total > 0 ? this.state.progress/this.state.total : 0} intent={Intent.SUCCESS} animate={this.state.uploading} />
            <div className="upload-row" style={{marginTop:'15px'}}>
                <div style={{flexGrow:'1'}}>
                    <Button active={this.state.showErrors} onClick={() => this.setState({showErrors : !this.state.showErrors})} minimal={true} intent={this.state.errors.length > 0 ? Intent.DANGER : Intent.NONE} disabled={this.state.errors.length < 1} text={i18n.t("upload.error",{count:this.state.errors.length})}/>

                </div>
                <Button style={{marginRight:'10px'}} disabled={!this.state.paused} onClick={() => this.resumeUpload()} intent={Intent.PRIMARY} icon="play">{i18n.t("upload.progress-resume")}</Button>
                <Button disabled={!!this.state.paused} onClick={() => this.pauseUpload()} intent={Intent.DANGER} icon="pause">{i18n.t("upload.progress-pause")}</Button>

            </div>
            <Collapse isOpen={this.state.showErrors}>
                <div  className="upload-collapse">
                    {this.state.errors.map((string) => {
                        return <div>{string}</div>
                    })}

                </div>
            </Collapse>
             


        </Card>;

        const TemplateListDialog = <Dialog isOpen={this.state.templateListOpen} title={i18n.t("template.templates")} onClose={this.closeOpenTemplate}>
            <div className="upload-templates-list" >
                {this.state.templateList.map(template => <TemplateButton onClick={this.openTemplate} template={template} loading={this.state.templateLoading} />)}
                {this.state.templateList && this.state.templateList.length === 0 && <div className="upload-template-empty">
                    {i18n.t("template.empty")}
                </div>}

            </div>
            <div className="bp3-dialog-footer">
                <div className="bp3-dialog-footer-actions">
                    <Button onClick={this.closeOpenTemplate} minimal={true} text={i18n.t('general.cancel')} />
                </div>
            </div>

        </Dialog>

        const ShareDialog = <Dialog isOpen={this.state.shareAlertOpen} onClose={() => this.setState({shareAlertOpen:false})} 
        title={i18n.t("template.set-sharing")}
        >
            <div className="bp3-dialog-body">
                {i18n.t("template.sharing-description")}

            </div>
            <div className="bp3-dialog-footer">
                <div className="bp3-dialog-footer-actions">

                    <Button loading={this.state.loading} onClick={() => this.setState({shareAlertOpen:false})} text={i18n.t("general.cancel")} intent={Intent.NONE} />
                    <Button loading={this.state.loading} onClick={() => this.saveTemplate(true)} text={i18n.t("template.share")} intent={Intent.WARNING} />
                    <Button loading={this.state.loading} onClick={() => this.saveTemplate(false)} text={i18n.t("template.private")} intent={Intent.PRIMARY} />
                </div>
            </div>



         </Dialog>;

        const {loading} = this.state;
        return <div id="body" className="divided">
            <FileDrop
            onDrop={(files,e) => {this.onFileChange(files[0])}}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="364.183" height="290.366" viewBox="0 0 364.183 290.366">
  <g id="Group_92" data-name="Group 92" transform="translate(-894.65 -357.695)">
    <g id="Group_91" data-name="Group 91" transform="translate(1018.046 357.695)">
      <g id="Path_88" data-name="Path 88" fill="none">
        <path d="M17.724,0H77.639c9.789,0,38.608,37.314,38.608,47.1V112.6a17.724,17.724,0,0,1-17.724,17.724h-80.8A17.724,17.724,0,0,1,0,112.6V17.724A17.724,17.724,0,0,1,17.724,0Z" stroke="none"/>
        <path d="M 17.72369384765625 9.999992370605469 C 13.46482849121094 9.999992370605469 9.999984741210938 13.46483612060547 9.999984741210938 17.72370147705078 L 9.999984741210938 112.5975952148438 C 9.999984741210938 116.8564682006836 13.46482849121094 120.3213119506836 17.72369384765625 120.3213119506836 L 98.52290344238281 120.3213119506836 C 102.7817535400391 120.3213119506836 106.2465896606445 116.8564682006836 106.2465896606445 112.5975952148438 L 106.2826461791992 47.64347076416016 C 104.8310775756836 39.8629150390625 84.05390930175781 13.58189392089844 76.67488861083984 9.999992370605469 L 17.72369384765625 9.999992370605469 M 17.72369384765625 0 L 77.63890838623047 0 C 87.42743682861328 0 116.2465896606445 37.31449127197266 116.2465896606445 47.10299682617188 L 116.2465896606445 112.5975952148438 C 116.2465896606445 122.3861236572266 108.3114318847656 130.3213043212891 98.52290344238281 130.3213043212891 L 17.72369384765625 130.3213043212891 C 7.935173034667969 130.3213043212891 -1.52587890625e-05 122.3861236572266 -1.52587890625e-05 112.5975952148438 L -1.52587890625e-05 17.72370147705078 C -1.52587890625e-05 7.935150146484375 7.935173034667969 0 17.72369384765625 0 Z" stroke="none" fill="#1f6b9a"/>
      </g>
      <path id="Path_86" data-name="Path 86" d="M7289.386,1060.984l20.939,20.94,20.94-20.94" transform="translate(-7252.512 -884.453)" fill="none" stroke="#1f6b9a" stroke-linecap="round" stroke-linejoin="round" stroke-width="7"/>
      <path id="Path_87" data-name="Path 87" d="M7289.386,1060.984l20.939,20.94,20.94-20.94" transform="translate(-7252.512 -863.513)" fill="none" stroke="#1f6b9a" stroke-linecap="round" stroke-linejoin="round" stroke-width="7"/>
      <path id="Path_89" data-name="Path 89" d="M12.254-11.071,8.417-17.258,4.729-11.071H-.32l6.138-9.257L.175-28.594h5.1l3.267,5.445,3.218-5.445h4.925L11.14-20.328l6.336,9.257Zm6.831,0V-28.594h4.257v13.836h6.782v3.688ZM41.361-24.04a3.821,3.821,0,0,0-1.423-1.1,4.015,4.015,0,0,0-1.7-.408,5.047,5.047,0,0,0-.854.074,2.2,2.2,0,0,0-.78.285,1.928,1.928,0,0,0-.582.545,1.45,1.45,0,0,0-.235.854,1.377,1.377,0,0,0,.186.743,1.652,1.652,0,0,0,.545.52,4.853,4.853,0,0,0,.854.408q.5.186,1.114.384.891.3,1.856.656a6.942,6.942,0,0,1,1.757.953,5,5,0,0,1,1.312,1.473,4.241,4.241,0,0,1,.52,2.19,5.723,5.723,0,0,1-.557,2.611,5.207,5.207,0,0,1-1.5,1.819,6.417,6.417,0,0,1-2.153,1.064,9.055,9.055,0,0,1-2.5.347,10.323,10.323,0,0,1-3.638-.656,7.709,7.709,0,0,1-2.921-1.869l2.772-2.822a5.122,5.122,0,0,0,1.7,1.324,4.6,4.6,0,0,0,2.091.532,4.209,4.209,0,0,0,.916-.1,2.284,2.284,0,0,0,.78-.322,1.611,1.611,0,0,0,.532-.594,1.87,1.87,0,0,0,.2-.891,1.41,1.41,0,0,0-.248-.842,2.418,2.418,0,0,0-.705-.631,5.682,5.682,0,0,0-1.139-.52q-.681-.235-1.547-.507a14.784,14.784,0,0,1-1.646-.644,5.509,5.509,0,0,1-1.436-.953,4.413,4.413,0,0,1-1.015-1.411,4.783,4.783,0,0,1-.384-2.017,4.96,4.96,0,0,1,.594-2.5,5.164,5.164,0,0,1,1.559-1.708,6.7,6.7,0,0,1,2.178-.978,9.876,9.876,0,0,1,2.45-.309,9.1,9.1,0,0,1,3.032.545,7.807,7.807,0,0,1,2.71,1.609ZM57.3-11.071l-3.836-6.188-3.688,6.188H44.727l6.138-9.257-5.643-8.267h5.1l3.267,5.445,3.218-5.445h4.925l-5.544,8.267,6.336,9.257Z" transform="translate(26.997 87.369)" fill="#1f6b9a"/>
    </g>
    <path id="Path_90" data-name="Path 90" d="M24.1-24.872a10.787,10.787,0,0,1-1.067,4.966,10.011,10.011,0,0,1-2.815,3.434,11.738,11.738,0,0,1-3.945,1.98,15.984,15.984,0,0,1-4.455.634H3.65v-21.9h7.92a19.575,19.575,0,0,1,4.579.541,11.492,11.492,0,0,1,4.022,1.794,9.185,9.185,0,0,1,2.846,3.357A11.272,11.272,0,0,1,24.1-24.872Zm-5.507,0a6.937,6.937,0,0,0-.6-3.078A5.183,5.183,0,0,0,16.381-29.9a6.436,6.436,0,0,0-2.289-1.036,11.252,11.252,0,0,0-2.645-.309H8.817v12.809h2.506a11.376,11.376,0,0,0,2.738-.325,6.472,6.472,0,0,0,2.32-1.067,5.288,5.288,0,0,0,1.609-1.98A6.958,6.958,0,0,0,18.594-24.872ZM39.323-13.857l-4.734-8.694H32.795v8.694H27.6v-21.9H35.95a14.508,14.508,0,0,1,3.078.325,8,8,0,0,1,2.692,1.1,5.745,5.745,0,0,1,1.9,2.042,6.377,6.377,0,0,1,.712,3.156A5.822,5.822,0,0,1,43.128-25.4a6.581,6.581,0,0,1-3.341,2.166l5.724,9.375Zm-.217-15.191a2.194,2.194,0,0,0-.325-1.253,2.226,2.226,0,0,0-.835-.743A3.629,3.629,0,0,0,36.8-31.4a8.443,8.443,0,0,0-1.222-.093H32.764v5.1H35.27A8.461,8.461,0,0,0,36.6-26.5a4.239,4.239,0,0,0,1.238-.387,2.362,2.362,0,0,0,.913-.8A2.384,2.384,0,0,0,39.106-29.048ZM70.942-24.9a12.215,12.215,0,0,1-.9,4.749,10.813,10.813,0,0,1-2.491,3.682,11.081,11.081,0,0,1-3.79,2.367A13.3,13.3,0,0,1,59-13.27a13.171,13.171,0,0,1-4.749-.835,11.113,11.113,0,0,1-3.775-2.367,10.813,10.813,0,0,1-2.491-3.682,12.215,12.215,0,0,1-.9-4.749,12.07,12.07,0,0,1,.9-4.749,10.4,10.4,0,0,1,2.491-3.6,11.1,11.1,0,0,1,3.775-2.289A13.624,13.624,0,0,1,59-36.35a13.753,13.753,0,0,1,4.765.8,11.067,11.067,0,0,1,3.79,2.289,10.4,10.4,0,0,1,2.491,3.6A12.07,12.07,0,0,1,70.942-24.9Zm-5.662,0a7.516,7.516,0,0,0-.464-2.661,6.34,6.34,0,0,0-1.284-2.119,5.927,5.927,0,0,0-1.98-1.392A6.268,6.268,0,0,0,59-31.585a6.16,6.16,0,0,0-2.537.51,6.142,6.142,0,0,0-1.98,1.392A6.022,6.022,0,0,0,53.2-27.563,7.749,7.749,0,0,0,52.75-24.9a7.826,7.826,0,0,0,.464,2.738,6.485,6.485,0,0,0,1.284,2.15,5.862,5.862,0,0,0,1.965,1.408A6.16,6.16,0,0,0,59-18.1a6.16,6.16,0,0,0,2.537-.51,6.03,6.03,0,0,0,1.98-1.408,6.349,6.349,0,0,0,1.3-2.15A7.826,7.826,0,0,0,65.28-24.9Zm25.772-4.115a6.72,6.72,0,0,1-.712,3.233,5.846,5.846,0,0,1-1.918,2.119,8.466,8.466,0,0,1-2.785,1.176,14.273,14.273,0,0,1-3.28.371h-2.63v8.261H74.438v-21.9h8.044a15.1,15.1,0,0,1,3.357.356,7.917,7.917,0,0,1,2.723,1.145,5.547,5.547,0,0,1,1.825,2.073A6.84,6.84,0,0,1,91.053-29.017Zm-5.291.031a2.358,2.358,0,0,0-.309-1.268,2.156,2.156,0,0,0-.835-.773,3.584,3.584,0,0,0-1.191-.371,9.955,9.955,0,0,0-1.377-.093h-2.32v5.167h2.228a7.945,7.945,0,0,0,1.423-.124,3.82,3.82,0,0,0,1.222-.433,2.32,2.32,0,0,0,.851-.82A2.441,2.441,0,0,0,85.762-28.987ZM107.2-31.245v4.517h8.477v4.362H107.2v8.508h-5.229v-21.9h14.418v4.517Zm12.592,17.388v-21.9h5.322v21.9Zm9.839,0v-21.9h5.322v17.295h8.477v4.61Zm16.274,0v-21.9h14.727v4.486h-9.622v4.115h9.1v4.239h-9.1v4.548h10.179v4.517Zm30.351-16.212a4.776,4.776,0,0,0-1.779-1.377,5.019,5.019,0,0,0-2.119-.51,6.309,6.309,0,0,0-1.067.093,2.756,2.756,0,0,0-.975.356,2.409,2.409,0,0,0-.727.681,1.812,1.812,0,0,0-.294,1.067,1.721,1.721,0,0,0,.232.928,2.065,2.065,0,0,0,.681.65,6.066,6.066,0,0,0,1.067.51q.619.232,1.392.48,1.114.371,2.32.82a8.678,8.678,0,0,1,2.2,1.191,6.252,6.252,0,0,1,1.64,1.841,5.3,5.3,0,0,1,.65,2.738,7.153,7.153,0,0,1-.7,3.264,6.509,6.509,0,0,1-1.872,2.274,8.021,8.021,0,0,1-2.692,1.33,11.318,11.318,0,0,1-3.125.433,12.9,12.9,0,0,1-4.548-.82,9.636,9.636,0,0,1-3.651-2.336l3.465-3.527a6.4,6.4,0,0,0,2.119,1.655,5.752,5.752,0,0,0,2.614.665,5.261,5.261,0,0,0,1.145-.124,2.855,2.855,0,0,0,.975-.4,2.014,2.014,0,0,0,.665-.743,2.337,2.337,0,0,0,.248-1.114,1.762,1.762,0,0,0-.309-1.052,3.023,3.023,0,0,0-.882-.789,7.1,7.1,0,0,0-1.423-.65q-.851-.294-1.934-.634a18.48,18.48,0,0,1-2.057-.8,6.887,6.887,0,0,1-1.794-1.191,5.517,5.517,0,0,1-1.269-1.764,5.978,5.978,0,0,1-.48-2.522,6.2,6.2,0,0,1,.743-3.125,6.454,6.454,0,0,1,1.949-2.135,8.373,8.373,0,0,1,2.723-1.222,12.345,12.345,0,0,1,3.063-.387,11.372,11.372,0,0,1,3.79.681,9.758,9.758,0,0,1,3.388,2.011Zm23.08-1.176v17.388h-5.291V-31.245h-6.188v-4.517h17.666v4.517ZM229.845-24.9a12.216,12.216,0,0,1-.9,4.749,10.814,10.814,0,0,1-2.491,3.682,11.081,11.081,0,0,1-3.79,2.367,13.3,13.3,0,0,1-4.765.835,13.171,13.171,0,0,1-4.749-.835,11.112,11.112,0,0,1-3.775-2.367,10.813,10.813,0,0,1-2.491-3.682,12.215,12.215,0,0,1-.9-4.749,12.07,12.07,0,0,1,.9-4.749,10.4,10.4,0,0,1,2.491-3.6,11.1,11.1,0,0,1,3.775-2.289,13.624,13.624,0,0,1,4.749-.8,13.753,13.753,0,0,1,4.765.8,11.067,11.067,0,0,1,3.79,2.289,10.4,10.4,0,0,1,2.491,3.6A12.07,12.07,0,0,1,229.845-24.9Zm-5.662,0a7.516,7.516,0,0,0-.464-2.661,6.34,6.34,0,0,0-1.284-2.119,5.927,5.927,0,0,0-1.98-1.392,6.268,6.268,0,0,0-2.552-.51,6.16,6.16,0,0,0-2.537.51,6.142,6.142,0,0,0-1.98,1.392,6.022,6.022,0,0,0-1.284,2.119,7.749,7.749,0,0,0-.449,2.661,7.826,7.826,0,0,0,.464,2.738,6.485,6.485,0,0,0,1.284,2.15,5.863,5.863,0,0,0,1.965,1.408,6.16,6.16,0,0,0,2.537.51,6.16,6.16,0,0,0,2.537-.51,6.03,6.03,0,0,0,1.98-1.408,6.349,6.349,0,0,0,1.3-2.15A7.826,7.826,0,0,0,224.183-24.9Zm35.456,2.785a9.428,9.428,0,0,1-.665,3.6,7.835,7.835,0,0,1-1.9,2.785,8.775,8.775,0,0,1-2.986,1.81,11.073,11.073,0,0,1-3.883.65,11.038,11.038,0,0,1-3.9-.65,8.468,8.468,0,0,1-2.939-1.81,7.858,7.858,0,0,1-1.856-2.785,9.625,9.625,0,0,1-.65-3.6V-35.762h5.26v13.211a6.111,6.111,0,0,0,.232,1.7,4.369,4.369,0,0,0,.712,1.439,3.337,3.337,0,0,0,1.268,1.006,4.441,4.441,0,0,0,1.9.371,4.441,4.441,0,0,0,1.9-.371,3.472,3.472,0,0,0,1.284-1.006,4,4,0,0,0,.712-1.439,6.519,6.519,0,0,0,.217-1.7V-35.762h5.291Zm20.884-6.9a6.72,6.72,0,0,1-.712,3.233,5.846,5.846,0,0,1-1.918,2.119,8.466,8.466,0,0,1-2.785,1.176,14.272,14.272,0,0,1-3.28.371H269.2v8.261h-5.291v-21.9h8.044a15.1,15.1,0,0,1,3.357.356,7.917,7.917,0,0,1,2.723,1.145,5.547,5.547,0,0,1,1.825,2.073A6.84,6.84,0,0,1,280.523-29.017Zm-5.291.031a2.358,2.358,0,0,0-.309-1.268,2.156,2.156,0,0,0-.835-.773A3.584,3.584,0,0,0,272.9-31.4a9.955,9.955,0,0,0-1.377-.093H269.2v5.167h2.228a7.946,7.946,0,0,0,1.423-.124,3.82,3.82,0,0,0,1.222-.433,2.32,2.32,0,0,0,.851-.82A2.441,2.441,0,0,0,275.232-28.987Zm8.477,15.129v-21.9h5.322v17.295h8.477v4.61ZM321.888-24.9a12.216,12.216,0,0,1-.9,4.749,10.814,10.814,0,0,1-2.491,3.682,11.081,11.081,0,0,1-3.79,2.367,13.3,13.3,0,0,1-4.765.835A13.171,13.171,0,0,1,305.2-14.1a11.112,11.112,0,0,1-3.775-2.367,10.813,10.813,0,0,1-2.491-3.682,12.216,12.216,0,0,1-.9-4.749,12.07,12.07,0,0,1,.9-4.749,10.4,10.4,0,0,1,2.491-3.6,11.1,11.1,0,0,1,3.775-2.289,13.624,13.624,0,0,1,4.749-.8,13.753,13.753,0,0,1,4.765.8,11.066,11.066,0,0,1,3.79,2.289,10.4,10.4,0,0,1,2.491,3.6A12.07,12.07,0,0,1,321.888-24.9Zm-5.662,0a7.516,7.516,0,0,0-.464-2.661,6.34,6.34,0,0,0-1.284-2.119,5.927,5.927,0,0,0-1.98-1.392,6.268,6.268,0,0,0-2.552-.51,6.16,6.16,0,0,0-2.537.51,6.142,6.142,0,0,0-1.98,1.392,6.022,6.022,0,0,0-1.284,2.119A7.749,7.749,0,0,0,303.7-24.9a7.825,7.825,0,0,0,.464,2.738,6.485,6.485,0,0,0,1.284,2.15,5.862,5.862,0,0,0,1.965,1.408,6.16,6.16,0,0,0,2.537.51,6.16,6.16,0,0,0,2.537-.51,6.03,6.03,0,0,0,1.98-1.408,6.35,6.35,0,0,0,1.3-2.15A7.826,7.826,0,0,0,316.227-24.9Zm23.452,11.045-1.7-4.3H329.5l-1.609,4.3h-5.755l9.189-21.9h5.136l9.1,21.9ZM333.8-29.915,331.015-22.4h5.507Zm34.033,5.043a10.787,10.787,0,0,1-1.067,4.966,10.01,10.01,0,0,1-2.815,3.434,11.738,11.738,0,0,1-3.945,1.98,15.984,15.984,0,0,1-4.455.634h-8.168v-21.9h7.92a19.574,19.574,0,0,1,4.579.541,11.492,11.492,0,0,1,4.022,1.794,9.186,9.186,0,0,1,2.846,3.357A11.272,11.272,0,0,1,367.833-24.872Zm-5.507,0a6.937,6.937,0,0,0-.6-3.078,5.183,5.183,0,0,0-1.609-1.949,6.436,6.436,0,0,0-2.289-1.036,11.253,11.253,0,0,0-2.645-.309h-2.63v12.809h2.506a11.376,11.376,0,0,0,2.738-.325,6.472,6.472,0,0,0,2.32-1.067,5.288,5.288,0,0,0,1.609-1.98A6.958,6.958,0,0,0,362.326-24.872Z" transform="translate(891 661.33)" fill="#1f6b9a"/>
  </g>
</svg>




            </FileDrop>
            {TemplateListDialog}
            {ShareDialog}
            <div className="divided-body">
                <div className="divided-body-menu">
                    <div className="upload-menu-title-description">{i18n.t("template.menu-title-description")}</div>
                    <H3><EditableText className="bp3-text-heading" value={this.state.title} onChange={this.changedTitle} onConfirm={this.confirmTitleChange } /></H3>
                    <div className="upload-menu-description">
                        {this.state.shared && <Tag intent={Intent.WARNING} style={{marginRight:'10px'}}>{i18n.t("template.shared")}</Tag>}
                        <span>{i18n.t("template.by", {name:!this.state.ownerName ? i18n.t("template.me") : this.state.ownerName})}</span>
                    </div>
                    <div className="upload-menu-title-menu">
                        <TitleMenu disabled={this.checkIsEmpty()} icon="document" menu="new" onClick={this.resetAll} />
                        <TitleMenu icon="folder-open" menu="open" onClick={this.showOpenTemplate} />
                        <Divider />
                        
                        <TitleMenu intent={(!this.checkIsEmpty() && this.state.owner) && this.state.changed ? Intent.DANGER : Intent.NONE} disabled={this.checkIsEmpty() || this.state.changed===false||this.state.owner ===false} icon="floppy-disk" menu="save" onClick={this.showSaveTemplate} />
                        <TitleMenu disabled={this.checkIsEmpty() || !this.state.templateIdx  } icon="duplicate" menu="save-as" onClick={this.showSaveAsTemplate} />
                        <Divider />
                        <TitleMenu disabled={!this.state.templateIdx || this.state.owner ===false} icon="trash" menu="delete" onClick={this.deleteTemplate} />
                    </div>
                </div>
                <div className={"divided-body-content upload-page-body" + (loading ? " loading" : "") }>
                    <h4 className="bp3-heading title">
                        {uploadIcon('#333')} UPLOAD DATA 
                    </h4>
                    <StepCard disabled={this.state.uploading} step={1} title={i18n.t("upload.card-title-1")}
                    subtitle={i18n.t("upload.card-subtitle-1")}
                    >
                        {Card1}
                    </StepCard>
                    <DownArrow />
                    <StepCard disabled={this.state.uploading} step={2} title={i18n.t("upload.card-title-2")}
                    subtitle={i18n.t("upload.card-subtitle-2")}
                    >
                        {Card2}
                    </StepCard>
                    <DownArrow />
                    <StepCard disabled={this.state.uploading} step={3} title={i18n.t("upload.card-title-3")}
                    subtitle={i18n.t("upload.card-subtitle-3")}
                    >
                        {Card3}
                    </StepCard>
                    <DownArrow />
                    <StepCard disabled={this.state.uploading} step={4} title={i18n.t("upload.card-title-4")}
                    >
                        {Card4}
                    </StepCard>
                    <DownArrow />
                    <div style={{textAlign:'center', marginTop:'20px', marginBottom:'20px', marginRight:'20px'}}>

                        <Button loading={this.state.uploading} onClick={()=>this.showSampleDialog()} intent={Intent.PRIMARY} large={true} text={i18n.t("upload.start-upload")} fill={true} rightIcon="cloud-upload" />
                    </div>
                    {ProgressCard}
                    {SampleDialog}

                </div>
                
            </div>
        </div>
    }
}


function TemplateButton(props) {
    return <Button fill={true} onClick={()=>props.onClick(props.template.template_idx)} className={props.loading ? "bp3-skeleton" : ""} minimal={true} style={{margin:'5px 0px'}}>
        <div className="upload-templates-list-item">
            <span className="name">{props.template.name}</span>
            <span className="shared">{parseInt(props.template.share)>0 && <Tag intent={Intent.WARNING}>{i18n.t("template.shared")}</Tag>}</span>
            <span className="matches">{Object.values(JSON.parse(props.template.matches)).length} {i18n.t("template.matches")}</span>

        </div>

    </Button>
}

export {UploadPage}